<template>
  <div class="col-md-12 col-sm-12 col-xs-12">
    <div class="form-group col-md-12 col-sm-12 col-xs-12" v-bind:class="errorPrice ? 'has-error' : ''">
      <label>Số tiền thanh toán<span class="error-symbol"></span></label>
      <currency-input v-model.number="oneTimePayment.price"
             placeholder="Nhập số tiền thanh toán ..."/>
    </div>
    <div class="form-group col-md-12 col-sm-12 col-xs-12">
      <label>Phương thức thanh toán</label>
      <multiselect v-model="oneTimePayment.paymentMethod" :options="paymentMethods" :multiple="false"
                   :close-on-select="true"
                   placeholder="Vui lòng chọn" label="text" track-by="value"></multiselect>
    </div>
    <div class="form-group col-md-12 col-sm-12 col-xs-12">
      <label>Ghi chú</label>
      <textarea
        class="form-control"
        id="textarea1"
        v-model="oneTimePayment.note"
        rows="3"
        style="height: 71px!important;"
      ></textarea>
    </div>
    <div class="form-group col-md-12 col-sm-12 col-xs-12">
      <label>Số hoá đơn</label>
      <input type="text" class="form-control" v-model="oneTimePayment.invoiceNo"
             placeholder="Nhập số hoá đơn..."/>
    </div>
    <div class="col-md-12 col-sm-12 col-xs-12">
      <div class="pull-right mt-3">
        <b-button variant="success" class="w-150px" @click="saveAnnualPayment" :disabled="saving">Thanh toán</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import PaymentApi from '../../api/payment'
import Utils from '../../common/utils'
import {mapGetters} from 'vuex'
import Multiselect from '../../lib/vue-multiple-select/Multiselect'
import {isNumber} from 'lodash'

export default {
  name: 'AnnualPayment',
  components: {
    Multiselect,
  },
  props: {
    orderId: {
      type: Number,
      required: false
    },
    orderHistory: {
      type: Object,
      required: false
    },
    onPaymentChanged: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      company: null,
      click: false,
      loading: false,
      saving: false,
      oneTimePayment: {
        price: 0,
        paymentMethod: {text: 'Chuyển khoản', value: 'TRANSFER'},
        note: null,
        invoiceNo: null
      },
      paymentMethods: [
        {text: 'Tiền mặt', value: 'CASH'},
        {text: 'Thẻ', value: 'CARD'},
        {text: 'Chuyển khoản', value: 'TRANSFER'}
      ]
    }
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ]),
    errorPrice () {
      return !isNumber(this.oneTimePayment.price) && this.click
    },
  },
  mounted () {
    this.company = Utils.getCompanyByUserInfo(this.userInfo)
  },
  methods: {
    saveAnnualPayment () {
      this.click = true
      this.saving = true
      this.loading = true
      const payment = {
        company_id: this.company.id,
        order_id: this.orderId,
        order_detail_id: this.orderHistory.id,
        type: 'ANNUAL_BUY',
        value: this.oneTimePayment.price,
        payment_method: this.oneTimePayment.paymentMethod.value,
        sale_note: this.oneTimePayment.note,
        invoice_no: this.oneTimePayment.invoiceNo,
      }
      PaymentApi.create(payment).then(res => {
        this.saving = false
        this.loading = false
        this.$bvModal.hide('annualPaymentModal')
        Utils.successToast(this.$bvToast)
        this.onPaymentChanged()
      }).catch(err => {
        this.saving = false
        this.loading = false
        Utils.handleError(this.$bvToast, err)
      })
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/order_management/AnnualPayment.vue